import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <div className="about-container">
        <h1 className="about-title">
          <img src="/logo_500.png" alt="MyWordBuddy Logo" className="about-logo" />
        </h1>
        
        <div className="about-section">
          <h2>📚 What is MyWordBuddy?</h2>
          <p>
            MyWordBuddy is a fun and safe way for elementary school children to learn new words! 
            Just type any word or phrase (even if you spell it wrong), and we'll explain it in a simple, easy-to-understand way with some example sentences.
          </p>
        </div>

        <div className="about-section">
          <h2>🛡️ Privacy & Safety</h2>
          <p>
            We care about your privacy! Here's what you should know:
          </p>
          <ul>
            <li>🔒 We don't store any personal information about you</li>
            <li>🚫 We explain words in an age-appropriate manner</li>
          </ul>
        </div>

        <div className="about-section">
          <h2>For Kids</h2>
          <p>
            The explanations aren't from a dictionary, so please double check with a dictionary or an adult if you're using them for homework.
          </p>
          <p>Have fun learning new words! 🎉</p>
        </div>

        <div className="about-section">
          <h2>👨‍💻 For Parents & Teachers</h2>
          <p>
            MyWordBuddy is a helpful tool to help kids explore and learn new words and phrases in a safe and age-appropriate way.
          </p>
          <p>
            Under the hood, it uses a large language model (LLM) to generate explanations. While we strive to provide accurate and appropriate content, please note that the explanations may not always be perfect. We recommend that you review the explanations to ensure they meet your standards and are suitable for your child's learning needs.
          </p>
        </div>

        <div className="about-section">
          <h2>📞 Feedback? Suggestions?</h2>
          <p>
            Reach out to me at upsides-42.doglegs at icloud.com
          </p>
        </div>

        <div className="footer-note">
          <p>
            Made with ❤️ for curious young minds
          </p>
          <p className="version-info">
            Copyright © 2025. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;